import * as React from 'react';
import { View } from 'react-native';
import AwesomeGallery from 'react-native-awesome-gallery';
import Modal from 'react-native-modal';
import { UnistylesRuntime, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';

import { NavigationButton, NavigationButtonTypes } from '../navigation-button';

export interface GalleryProps {
  navTitle: string;
  data: string[];
  onDismiss: () => void;
  initialIndex?: number;
  visible?: boolean;
}

export default function Gallery({
  navTitle,
  data,
  onDismiss,
  initialIndex = 0,
  visible = false,
}: GalleryProps) {
  const { theme } = useStyles();
  const [index, setIndex] = React.useState(1);

  return (
    <View>
      <Modal
        animationIn="slideInUp"
        animationInTiming={300}
        animationOut="slideOutDown"
        isVisible={visible}
        hasBackdrop
        style={{ margin: 0 }}
        onDismiss={() => {
          onDismiss();
        }}
      >
        <View
          style={{
            flexGrow: 1,
            justifyContent: 'center',
            backgroundColor: theme.colors.background_1,
          }}
        >
          <AwesomeGallery
            data={data}
            onIndexChange={(newIndex: number) => {
              setIndex(newIndex + 1);
            }}
            initialIndex={initialIndex}
            style={{ backgroundColor: theme.colors.background_1 }}
          />

          <View
            style={{
              width: '100%',
              height: 50,
              position: 'absolute',
              top: 0,
              marginTop: UnistylesRuntime.insets.top,
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <NavigationButton
              type={NavigationButtonTypes.back}
              onPress={() => {
                onDismiss();
              }}
              style={{
                position: 'absolute',
                left: 0,
              }}
            />

            <Text type="title2">{navTitle}</Text>
          </View>

          <View
            style={{
              width: '100%',
              height: 50,
              position: 'absolute',
              bottom: 0,
              marginBottom: UnistylesRuntime.insets.bottom,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Text type="bodyBold">{`${index} of ${data.length}`}</Text>
          </View>
        </View>
      </Modal>
    </View>
  );
}
